import { AnyAction, Dispatch } from "@reduxjs/toolkit";
// import Web3 from "web3";
import { Web3Helper } from "./web3Helper";
import { crucibleApi } from "../../_apis/CrucibleApi";
import { toast } from "react-hot-toast";

export class CrucibleClient {
  public web3Client: Web3Helper;

  constructor(Web3Client: Web3Helper) {
    this.web3Client = Web3Client;
  }

  __name__() {
    return "CrucibleClient";
  }

  async getContractAllocation(
    userAddress: string,
    contractAddress: string,
    currency: string
  ): Promise<any> {
    const Api = new crucibleApi();
    await Api.signInToServer(userAddress);
    return Api.crucibleApi({
      command: "getContractAllocation",
      data: { userAddress, contractAddress, currency },
      params: [],
    });
  }

  async setContractAllocation(
    dispatch: any,
    userAddress: string,
    contractAddress: string,
    currency: string,
    network: string,
    amount?: string
  ): Promise<any> {
    const Api = new crucibleApi();
    await Api.signInToServer(userAddress);
    const requests = await Api.crucibleApi({
      command: "approveAllocationGetTransaction",
      data: { currency, amount: amount || "1", userAddress, contractAddress },
      params: [],
    });
    console.log("About to submit request", { requests });

    if (requests.data.length) {
      return await this.sendEthTransaction(
        requests.data.length > 1 ? requests.data[1] : requests.data[0]
      );
    }
    return "";
  }

  async mintCrucible(
    dispatch: Dispatch<AnyAction>,
    currency: string,
    crucibleAddress: string,
    amount: string,
    isPublic: boolean,
    network: string,
    userAddress: string,
    dialogTrigger: (value: React.SetStateAction<boolean>) => void
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const request = await Api.crucibleApi({
        command: isPublic
          ? "depositPublicGetTransaction"
          : "depositGetTransaction",
        data: { network, currency, crucible: crucibleAddress, amount },
      });

      if (request.data.data) {
        // console.log(request.data,'datataatat')
        return await this.sendEthTransaction(request.data);
      }

      return;
    } catch (e) {
      dialogTrigger(false);
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async unwrapCrucible(
    dispatch: Dispatch<AnyAction>,
    currency: string,
    crucibleAddress: string,
    amount: string,
    isPublic: boolean,
    network: string,
    userAddress: string,
    dialogTrigger: (value: React.SetStateAction<boolean>) => void
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const request = await Api.crucibleApi({
        command: "withdrawGetTransaction",
        data: { network, currency, crucible: crucibleAddress, amount },
      });

      if (request.data.data) {
        // console.log(request.data,'datataatat')
        return await this.sendEthTransaction(request.data);
      }

      return;
    } catch (e: any) {
      dialogTrigger(false);
      toast.error(e?.message);
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async getConfiguredCrucibleRouters(
    dispatch: Dispatch<AnyAction>,
    userAddress: string
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);

      const response = await Api.crucibleApi({
        command: "getConfiguredRouters",
        data: { userAddress },
        params: [],
      });

      return response;
    } catch (e) {
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async getUserCrucibleInfo(
    dispatch: Dispatch<AnyAction>,
    crucibleAddress: string,
    userAddress: string
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const userCrucibleInfo = await Api.crucibleApi({
        command: "getUserCrucibleInfo",
        data: { crucible: crucibleAddress, userAddress },
        params: [],
      });
      if (!!userCrucibleInfo) {
        return userCrucibleInfo;
      }
      return;
    } catch (e) {
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async getLPStakingInfo(
    dispatch: Dispatch<AnyAction>,
    crucibleAddress: string,
    userAddress: string,
    stakingAddress: string,
    network: string
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const userCrucibleInfo = await Api.crucibleApi({
        command: "userStakeInfo",
        data: {
          crucible: crucibleAddress,
          stakeType: "openEnded",
          stakeId: crucibleAddress,
          network: network,
          stakingAddress: stakingAddress,
          userAddress,
        },
        params: [],
      });
      if (!!userCrucibleInfo) {
        // // console.log(userCrucibleInfo, "user crucible info")
        return userCrucibleInfo;
      }
      return;
    } catch (e) {
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async stakeLPToken(
    dispatch: Dispatch<AnyAction>,
    LpAddress: string,
    userAddress: string,
    stakingAddress: string,
    network: string,
    amount: string,
    dialogTrigger: (value: React.SetStateAction<boolean>) => void
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const request = await Api.crucibleApi({
        command: "stakeGetTransaction",
        data: {
          currency: `${network}:${LpAddress}`,
          stakeType: "openEnded",
          stakeId: LpAddress,
          network: network,
          amount,
          stakingAddress: stakingAddress,
          userAddress,
        },
        params: [],
      });
      if (request.data.data) {
        // console.log(request.data)
        return await this.sendEthTransaction(request.data);
      }

      return;
    } catch (e) {
      dialogTrigger(false);
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async unstakeLPToken(
    dispatch: Dispatch<AnyAction>,
    LpAddress: string,
    userAddress: string,
    amount: string,
    stakingAddress: string,
    network: string,
    dialogTrigger: (value: React.SetStateAction<boolean>) => void
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const request = await Api.crucibleApi({
        command: "withdrawStakeGetTransaction",
        data: {
          currency: `${network}:${LpAddress}`,
          stakeType: "openEnded",
          stakeId: LpAddress,
          network: network,
          amount,
          stakingAddress: stakingAddress,
          userAddress,
        },
        params: [],
      });
      if (request.data.data) {
        return await this.sendEthTransaction(request.data);
      }
      return;
      // return
    } catch (e) {
      dialogTrigger(false);
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async withdrawRewardsLPToken(
    dispatch: Dispatch<AnyAction>,
    LpAddress: string,
    userAddress: string,
    stakingAddress: string,
    network: string,
    dialogTrigger: (value: React.SetStateAction<boolean>) => void
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const request = await Api.crucibleApi({
        command: "takeRewardsGetTransaction",
        data: {
          stakeType: "openEnded",
          stakeId: LpAddress,
          network: network,
          stakingAddress: stakingAddress,
          userAddress,
        },
        params: [],
      });

      if (request.data.data) {
        return await this.sendEthTransaction(request.data);
      }
      return;
    } catch (e) {
      dialogTrigger(false);
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async getPairPrice(
    dispatch: Dispatch,
    crucible: string,
    base: string,
    userAddress: string
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const cruciblePairPrice = await Api.crucibleApi({
        command: "getCruciblePricing",
        data: { crucible, base },
        params: [],
      });
      if (!!cruciblePairPrice) {
        // console.log(cruciblePairPrice)
        return cruciblePairPrice.data;
      }
      return cruciblePairPrice;
    } catch (e) {
      // console.log(e)
    }
  }

  async getAllCruciblesFromDb(
    dispatch: Dispatch<AnyAction>,
    network: string,
    userAddress: string
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);

      const crucibles = await Api.crucibleApi({
        command: "getAllCruciblesFromDb",
        data: { network },
        params: [],
      });

      return crucibles || [];
    } catch (e) {
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  // async getAllCrucibles(
  //     dispatch: Dispatch<AnyAction>,
  //     network: string,
  //     userAddress: string
  // ) {
  // 	try {

  //         const cs = await this.getAllCruciblesFromDb(dispatch, network,userAddress) as any;
  // 		// console.log(cs,"crucible")
  //         if(cs?.length){
  // 			for(const c of cs) {
  // 				this.updateCrucible(dispatch, network, c.contractAddress,userAddress);
  // 			}
  // 		}
  // 		return

  // 	} catch (e) {
  //         // console.log(e)
  //         // UI handle Errors
  // 	}finally{
  //         // Handle Modal Close
  // 	}

  // }

  async getCrucibleDetails(
    dispatch: Dispatch<AnyAction>,
    network: string,
    contractAddress: string,
    userAddress: string
  ) {
    const Api = new crucibleApi();
    await Api.signInToServer(userAddress);

    const crucible = await Api.crucibleApi({
      command: "getCrucible",
      data: { crucible: `${network.toUpperCase()}:${contractAddress}` },
      params: [],
    });

    return crucible;
  }

  async mintAndStakeCrucible(
    dispatch: Dispatch<AnyAction>,
    currency: string,
    crucibleAddress: string,
    amount: string,
    stakeAddress: boolean,
    network: string,
    userAddress: string,
    dialogTrigger: (value: React.SetStateAction<boolean>) => void
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const request = await Api.crucibleApi({
        command: "depositAndStakeGetTransaction",
        data: {
          network,
          currency,
          crucible: crucibleAddress,
          stake: stakeAddress,
          amount,
        },
        params: [],
      });
      if (request.data.data) {
        return await this.sendEthTransaction(request.data);
      }

      return;
    } catch (e) {
      dialogTrigger(false);
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async StakeCrucible(
    dispatch: Dispatch<AnyAction>,
    LPorCruciblecurrency: string,
    amount: string,
    stakingAddress: string,
    userAddress: string,
    network: string,
    dialogTrigger: (value: React.SetStateAction<boolean>) => void
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const request = await Api.crucibleApi({
        command: "stakeForGetTransaction",
        data: {
          currency: LPorCruciblecurrency,
          stake: stakingAddress,
          network,
          amount,
        },
        params: [],
      });
      let response;
      if (request.data.data) {
        response = await this.sendEthTransaction(request.data);
        return response;
      }
      return response;
    } catch (e) {
      dialogTrigger(false);
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async UnStakeCrucible(
    dispatch: Dispatch<AnyAction>,
    LPorCruciblecurrency: string,
    amount: string,
    stakingAddress: string,
    userAddress: string,
    network: string,
    dialogTrigger: (value: React.SetStateAction<boolean>) => void
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const request = await Api.crucibleApi({
        command: "unStakeGetTransaction",
        data: {
          crucible: LPorCruciblecurrency,
          staking: stakingAddress,
          network,
          amount,
        },
        params: [],
      });

      if (request.data.data) {
        return await this.sendEthTransaction(request.data);
      }

      return;
    } catch (e) {
      dialogTrigger(false);
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  async withdrawRewards(
    dispatch: Dispatch<AnyAction>,
    network: string,
    amount: string,
    LPorCruciblecurrency: string,
    stakingAddress: string,
    userAddress: string,
    dialogTrigger: (value: React.SetStateAction<boolean>) => void
  ) {
    try {
      const Api = new crucibleApi();
      await Api.signInToServer(userAddress);
      const request = await Api.crucibleApi({
        command: "withdrawRewardsGetTransaction",
        data: {
          crucible: `${LPorCruciblecurrency}`,
          staking: stakingAddress,
          amount,
        },
        params: [],
      });
      let response;

      if (request.data.data) {
        response = await this.sendEthTransaction(request.data);
        return response;
      }

      return response;
    } catch (e) {
      dialogTrigger(false);
      // console.log(e)
      // UI handle Errors
    } finally {
      // Handle Modal Close
    }
  }

  private getGasFees = async (network: number, type = "GENERAL") => {
    const response = await fetch(
      `https://api-gateway-v1.svcs.ferrumnetwork.io/api/v1/gasFees/${network}?type=${type}`
    );

    if (response.status == 200) {
      const res = await response.json();
      return res.body.gasFees;
    }
    return null;
  };

  private networkOverrides = async (
    transactions: any[],
    networkItem?: string
  ) => {
    console.log(transactions);
    const networks = {
      ETHEREUM_ARBITRUM: {
        maxFeePerGas: 200000000,
        maxPriorityFeePerGas: 100000000,
        gas: 3500000000,
        gasLimit: 4000000,
      },
      BSC: {
        maxFeePerGas: 3500000000,
        maxPriorityFeePerGas: 3500000000,
        gas: 3500000000,
        gasLimit: 2000000,
      },
      ETHEREUM: {
        maxFeePerGas: 100000000000,
        maxPriorityFeePerGas: 800000000,
        gas: 550000000,
        gasLimit: 1000000,
      },
    };

    const networksMap = {
      ETHEREUM_ARBITRUM: 42161,
      BSC: 56,
      ETHEREUM: 1,
      POLYGON_MAINNET: 137,
      POLYGON: 137,
      AVAX_MAINNET: 43114,
      AVAX: 43114,
    };

    const res = await Promise.all(
      transactions.map(async (e: any) => {
        const txType =
          e?.description && e?.data.startsWith("0x095ea7b")
            ? "approval"
            : "general";
        const network = (e.currency.split(":") || [])[0] || networkItem;
        const chainId = networksMap[network as keyof typeof networksMap];
        //@ts-ignore
        const gasOverride = networks[network as any];
        const gasRes = await this.getGasFees(chainId, txType);
        if (chainId && gasRes) {
          const gasFee = {
            gas: gasRes?.gasLimit,
            gasLimit: Number(gasRes.gasLimit),
            maxFeePerGas: Number(gasRes.maxFeePerGas) * 1000000000,
            maxPriorityFeePerGas:
              Number(gasRes.maxPriorityFeePerGas) * 1000000000,
          };
          e.gas = gasFee;
          return e;
        } else {
          if (network && gasOverride) {
            e.gas = gasOverride;
            return e;
          } else {
            return e;
          }
        }
      })
    );
    return res;
  };

  async contract(userAddress: string, network: string) {
    //@ts-ignore
    const Api = new crucibleApi();
    await Api.signInToServer(userAddress);
    const response = await Api.crucibleApi({
      command: "getCrucible",
      data: {},
      params: [],
    });

    return response;
  }

  sendEthTransaction = async (request: any) => {
    console.log("sendEthTransaction request", request);
    try {
      let response;
      const { ethereum } = window as any;
      if (request) {
        const txHash = await ethereum.request({
          method: "eth_sendTransaction",
          params: [
            {
              from: request.from,
              to: request.contract,
              data: request.data,
            },
          ],
        });
        console.log("txHash", txHash);
        if (txHash) {
          while (response == undefined) {
            response = await this.web3Client.checkTransactionReceipt(txHash);
            await new Promise((resolve) => setTimeout(resolve, 1500));
          }
          console.log("response", response);
        }
        return response;
      }
    } catch (e: any) {
      console.log(e);
      toast.error(e?.message);
    }
  };
}
